import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";

export default function Users() {
  const { data: users = [] } = useQuery({ queryKey: ["admin-users"], queryFn: () => get("/admin/users") });

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Kullanıcılar</h1>
      <p className="text-sm text-[#475569]">Toplam {users.length} kullanıcı</p>

      <div className="mt-5 overflow-hidden rounded border border-[#CBD5E1] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#E2E8F0] text-left text-xs uppercase tracking-wide text-[#475569]">
            <tr><th className="px-4 py-2.5">Ad Soyad</th><th className="px-4 py-2.5">E-posta</th><th className="px-4 py-2.5">Şehir</th><th className="px-4 py-2.5">Üyelik</th><th className="px-4 py-2.5 text-right">Kredi</th></tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {users.map((u) => (
              <tr key={u.id} data-testid={`admin-user-${u.id}`} className="hover:bg-[#F8FAFC]">
                <td className="px-4 py-2.5 font-medium">{u.name}</td>
                <td className="px-4 py-2.5 text-[#475569]">{u.email}</td>
                <td className="px-4 py-2.5 text-[#475569]">{u.city}</td>
                <td className="px-4 py-2.5 text-[#475569]">{u.member_since}</td>
                <td className="px-4 py-2.5 text-right font-medium">{u.credits}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
